import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=6746a0a8&scoped=true&"
import script from "./Wizard.vue?vue&type=script&lang=ts&"
export * from "./Wizard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6746a0a8",
  null
  
)

export default component.exports